<template>
  <div class="resume-preview-container">
    <PcNavbar />
    <template v-if="!isLoading">
      <div class="resume-preview-content">
        <div class="resume-wrapper">
          <Resume />
        </div>
        <div class="right-content">
          <div class="right-content-title">AI 智能简历已生成</div>
          <div class="template-title">模版风格</div>
          <div class="resume-template-list">
            <div
              v-for="(item, index) in templates"
              :key="index"
              class="template-item-wrapper cursor-pointer"
              :class="{ active: activeImage === item.imgSrc }"
              @click="clickTemplateItem(item)"
            >
              <div class="template-content">
                <img :src="item.imgSrc" alt="" />
              </div>
            </div>
          </div>
          <div class="bottom-btns-content">
            <OnboardingBtn text="编辑简历" :width="148" @click="editResume" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import PcNavbar from '@/components/base/navbar';
import Resume from '../editor2025/components/ResumePreview/resume.vue';
import { CN_CV_STYLES } from '@/assets/js/const';
import { routerTo } from '@/assets/js/util';
import OnboardingBtn from './components/OnboardingBtn.vue';
import { formatOperationMixin } from '@/views/editor2025/mixins/format-operation';
import recommendTemplateStyle from '@/assets/json/recommend-template-style.json';

export default {
  name: 'AiResumePreview',
  mixins: [formatOperationMixin],
  components: {
    PcNavbar,
    Resume,
    OnboardingBtn,
  },
  data() {
    return {
      isLoading: true,
      CN_CV_STYLES,
    };
  },
  computed: {
    ...mapState('editor', ['resumeWidth']),
    templates() {
      return recommendTemplateStyle['editor_2025'].filter((item) => item.onboardingPreview);
    }
  },
  methods: {
    ...mapActions('editor', ['getCvDetail', 'getCvInfoData']),
    editResume() {
      routerTo(`/cvs/${this.cvDetail.basic_info.token}/editor`);
    },
    async fetchResumeData(token) {
      try {
        await this.getCvDetail(token);
        await this.getCvInfoData({
          check: false,
          only_desc: false,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    const token = this.$route.params.token;
    this.fetchResumeData(token);
    this.$store.commit('editor/setResumeWidthByValue', 460);
  },
};
</script>
<style lang="scss" scoped>
.resume-preview-container {
  padding-top: 116px;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #191c20;
  .resume-preview-content {
    display: flex;
    justify-content: center;
    align-items: center;
    .resume-wrapper {
      width: 460px;
      height: 650px;
      overflow: hidden;
      margin-right: 60px;
      border-radius: 16px;
      :deep(.line-header),
      :deep(.left_block-header),
      :deep(.block-header),
      :deep(.circle-header) {
        .works {
          margin-left: 0;
        }
      }
    }
    .right-content {
      width: 680px;
      .right-content-title {
        font-size: 32px;
        font-weight: 600;
        line-height: normal;
        background: linear-gradient(90deg, #febe5d 0%, #fe6644 38.24%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 32px;
      }
      .template-title {
        font-size: 18px;
        font-weight: 600;
        line-height: 16px;
        margin-bottom: 12px;
        color: #fff;
      }
      .resume-template-list {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 32px;
        .template-item-wrapper {
          .template-content {
            width: 155px;
            height: 226px;
            border-radius: 8px;
            overflow: hidden;
            background-color: #fff;
            img {
              display: block;
              width: 100%;
              object-fit: cover;
              object-position: top;
            }
          }
          &.active {
            @apply relative;
            &::after {
              content: '';
              display: inline-block;
              width: calc(100% + 8px);
              height: calc(100% + 8px);
              border: 4px solid #ff6644;
              position: absolute;
              top: -4px;
              left: -4px;
              right: -4px;
              bottom: -4px;
              border-radius: 12px;
            }
          }
        }
      }
      .bottom-btns-content {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
</style>
